import React from "react";

const AboutPage = () => {
  return (
    <div>
      <h2>Welcome to the About Page!</h2>
      <p>This app is about learning something new</p>
    </div>
  );
};

export default AboutPage;
